import prettier from 'prettier/standalone';
import babel from 'prettier/parser-babel';
import SyntaxHighlighter from 'react-syntax-highlighter';

import React from 'react';
import styled from '@emotion/styled';

interface CodeProps {
	value: string;
}

const Highlighter = styled(SyntaxHighlighter)`
	background: none !important;
`;

export const Json: React.FC<CodeProps> = ({ value }) => (
	<Highlighter language="json">
		{prettier
			.format(value, {
				parser: 'json',
				plugins: [babel]
			})
			.replace(/[\r\n]+$/, '')}
	</Highlighter>
);
